module.exports = __webpack_public_path__ + "static/media/swapContentbox1.e95e611e.png";